import Constants from "../utils/consts";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function getSessioniLezione(uname, token, id_lezione) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "getSessioniLezione.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);
        var bodyStr = body.toString();

        // Gestisce risposte vuote o non JSON (backend non ancora implementato)
        if (!bodyStr || bodyStr.trim() === "") {
          console.warn(
            "getSessioniLezione: API backend non risponde (probabilmente non ancora implementata)"
          );
          resolve([]); // Restituisce array vuoto = nessuna sessione
          return;
        }

        try {
          const resp = JSON.parse(bodyStr);

          console.log("[getSessioniLezione] Risposta backend:", resp);

          // Gestisce sia il formato {result: "ok", sessioni: [...]} che array diretto
          if (resp.result === "ok" && Array.isArray(resp.sessioni)) {
            resolve(resp.sessioni);
          } else if (Array.isArray(resp)) {
            resolve(resp);
          } else {
            console.warn(
              "[getSessioniLezione] Formato risposta non riconosciuto:",
              resp
            );
            resolve([]);
          }
        } catch (e) {
          console.error(
            "Errore parsing risposta getSessioniLezione:",
            e,
            "Body:",
            bodyStr
          );
          resolve([]); // Restituisce array vuoto se non ci sono sessioni
        }
      });

      res.on("error", function(error) {
        console.error(error);
        reject(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      id_lezione: id_lezione,
    });

    req.write(postData);

    req.end();
  });
}
